/* IZECOmfort · aviso de cookies de Shopify en español (los textos se editan en el pie de página) */
(function(){
'use strict';
var D={
  title:'Tu privacidad',
  text:'Nosotros y nuestros socios, incluido Shopify, usamos cookies para personalizar tu experiencia, mostrarte anuncios y medir el uso de la web. Solo las usamos para esto si las aceptas. Más información en nuestra',
  link:'Política de privacidad',
  accept:'Aceptar',decline:'Rechazar',prefs:'Preferencias',
  p_title:'Preferencias de privacidad',p_accept:'Aceptar todo',p_decline:'Rechazar todo',p_save:'Guardar mi elección',p_close:'Cerrar',
  p_intro_h:'Tú decides',p_intro:'Elige qué cookies permites. Puedes cambiarlo cuando quieras.',
  essential:['Necesarias','Hacen que la web funcione bien: iniciar sesión, añadir productos al carrito y pagar.'],
  preferences:['Personalización','Recuerdan lo que haces en la web para personalizar tu próxima visita.'],
  marketing:['Marketing','Las usamos nosotros y nuestros socios, incluido Shopify, para mejorar nuestras comunicaciones y mostrarte anuncios en otras webs.'],
  analytics:['Análisis','Nos ayudan a entender cómo usas la web para mejorarla.']
};
var T=D;
try{var el=document.getElementById('izc-ck-txt');if(el){var j=JSON.parse(el.textContent);for(var k in j){if(j[k])T[k]=j[k];}}}catch(_){}
function txt(node,s){if(node&&s)node.textContent=s;}
function firstText(el){if(!el)return null;for(var i=0;i<el.childNodes.length;i++){var n=el.childNodes[i];if(n.nodeType===3&&n.textContent.trim())return n;}return null;}
function banner(){
  var b=document.getElementById('shopify-pc__banner');if(!b||b.dataset.izc)return;b.dataset.izc='1';
  txt(document.getElementById('shopify-pc__banner__body-title'),T.title);
  var a=document.getElementById('shopify-pc__banner__body-policy-link'),p=a?a.parentNode:b.querySelector('.shopify-pc__banner__body p');
  if(p){p.textContent='';p.appendChild(document.createTextNode(T.text+' '));if(a){a.textContent=T.link;p.appendChild(a);}p.appendChild(document.createTextNode('.'));}
  txt(document.getElementById('shopify-pc__banner__btn-accept'),T.accept);
  txt(document.getElementById('shopify-pc__banner__btn-decline'),T.decline);
  var m=document.getElementById('shopify-pc__banner__btn-manage-prefs');if(m)txt(m.querySelector('span')||m,T.prefs);
  b.setAttribute('aria-label',T.title);
}
function prefs(){
  var d=document.getElementById('shopify-pc__prefs__dialog');if(!d||d.dataset.izc)return;d.dataset.izc='1';
  txt(document.getElementById('shopify-pc__prefs__header-title'),T.p_title);
  txt(document.getElementById('shopify-pc__prefs__header-accept'),T.p_accept);
  txt(document.getElementById('shopify-pc__prefs__header-decline'),T.p_decline);
  txt(document.getElementById('shopify-pc__prefs__header-save'),T.p_save);
  var c=document.getElementById('shopify-pc__prefs__header-close');if(c)c.setAttribute('aria-label',T.p_close);
  var intro=d.querySelector('.shopify-pc__prefs__intro-main');if(intro){txt(intro.querySelector('h3'),T.p_intro_h);txt(intro.querySelector('p'),T.p_intro);}
  ['essential','preferences','marketing','analytics'].forEach(function(k){
    var o=document.getElementById('shopify-pc__prefs__'+k);if(!o||!T[k])return;
    var n=firstText(o.querySelector('label'));if(n)n.textContent=T[k][0]+' ';
    txt(o.querySelector('p'),T[k][1]);
  });
}
function run(){banner();prefs();}
run();
if('MutationObserver' in window){
  var q=0;new MutationObserver(function(){if(q)return;q=requestAnimationFrame(function(){q=0;run();});}).observe(document.documentElement,{childList:true,subtree:true});
}
})();
